import {noop} from '@benchling/js-utils';
import classNames from 'classnames';
import React from 'react';

interface FeatureTextProps {
  active: boolean;
  header: string;
  text: string;
  sectionIndex: number;
  updateActiveSection: (sectionIndex: number) => void;
}

const FeatureText = ({
  active,
  header,
  text,
  sectionIndex,
  updateActiveSection,
}: FeatureTextProps): JSX.Element => (
  <div
    onClick={(): void => {
      updateActiveSection(sectionIndex);
    }}
    className={classNames('entryScreen-featureText', {'entryScreen-featureText--active': active})}
  >
    <h3>{header}</h3>
    <p>{text}</p>
  </div>
);

interface FeaturePreviewScreenProps {
  header: string;
  backgroundImage?: string;
  nextButtonText: string;
  subheader: React.ReactNode;
  handleClickNextScreen: () => void;
  featureInfos: Array<{
    header: string;
    text: string;
    imageName: string;
  }>;
  onChangeActiveSection?: (activeSection: string) => void;
}

interface FeaturePreviewScreenState {
  activeSection: number;
}

class FeaturePreviewScreen extends React.Component<FeaturePreviewScreenProps, FeaturePreviewScreenState> {
  static defaultProps = {nextButtonText: 'Next', onChangeActiveSection: () => noop};
  state: FeaturePreviewScreenState = {activeSection: 0};

  updateActiveSection = (activeSection: number): void => {
    if (this.state.activeSection !== activeSection) {
      this.props.onChangeActiveSection!(this.props.featureInfos[activeSection].header);
    }
    this.setState({activeSection});
  };

  render(): JSX.Element {
    const featureImage = this.props.featureInfos[this.state.activeSection].imageName;
    const featureImageClassName = `featurePreviewScreen-featureImage-${featureImage.split('.')[0]}`;

    return (
      <div>
        <div className="infoScreen-container">
          <div className="infoScreen-content infoScreen-leftRightScreen-left">
            <h1>{this.props.header}</h1>
            <p>{this.props.subheader}</p>
            {this.props.featureInfos.map(({header, text}, i) => (
              <FeatureText
                key={`feature-text-${i}`}
                header={header}
                text={text}
                active={this.state.activeSection === i}
                sectionIndex={i}
                updateActiveSection={this.updateActiveSection}
              />
            ))}
          </div>
          <div className="u-position-relative infoScreen-leftRightScreen-right">
            {this.props.backgroundImage && (
              <img
                src={`/static/img/new-user-flow/${this.props.backgroundImage}`}
                className="infoScreen-previewImage-img"
              />
            )}
            <img
              src={`/static/img/new-user-flow/${featureImage}`}
              className={`featurePreviewScreen-featureImage ${featureImageClassName}`}
            />
          </div>
        </div>
        <div className="infoScreen-nextScreenButtonContainer">
          <button
            className="button button--large button--primary infoScreen-nextScreenButton"
            onClick={this.props.handleClickNextScreen}
            type="button"
          >
            {this.props.nextButtonText}
          </button>
        </div>
      </div>
    );
  }
}

export default FeaturePreviewScreen;
